// extracted by mini-css-extract-plugin
export default {"container":"style_container__tgd-r","titleFirst":"style_titleFirst__tflpW","titleSecond":"style_titleSecond__K8T7d"};